import React from 'react';

const steps = [
  "Placed",
  'Order Confirmed',
  'Shipped',
  'Out For Delivery',
  'Delivered'
];

export default function OrderTraker({ activeStep }) {
  return (
    <div className="bg-black text-white py-6 px-4 lg:px-32">
      <div className="flex flex-wrap justify-between gap-4 mb-8">
        {steps.map((label, index) => (
          <div key={label} className="flex-1 text-center">
            <div
              className={`p-2 rounded-full mb-2 w-8 h-8 flex items-center justify-center mx-auto
                ${activeStep >= index ? 'bg-blue-500 text-white' : 'bg-gray-600 text-gray-400'
                }`}
            >
              {index + 1}
            </div>
            <p
              className={`text-xs sm:text-sm md:text-base ${activeStep >= index ? 'text-white' : 'text-gray-500'
                }`}
            >
              {label}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
